// ++  co
//
// See arvo/sys/hoon.hoon.
var BN = require('bn.js');

var lodash = require('lodash');

var ob = require('./ob');

var zero = new BN(0);
var one = new BN(1);
var two = new BN(2);
var three = new BN(3);
var four = new BN(4);
var five = new BN(5);
var pre = "\ndozmarbinwansamlitsighidfidlissogdirwacsabwissibrigsoldopmodfoglidhopdardorlorhodfolrintogsilmirholpaslacrovlivdalsatlibtabhanticpidtorbolfosdotlosdilforpilramtirwintadbicdifrocwidbisdasmidloprilnardapmolsanlocnovsitnidtipsicropwitnatpanminritpodmottamtolsavposnapnopsomfinfonbanmorworsipronnorbotwicsocwatdolmagpicdavbidbaltimtasmalligsivtagpadsaldivdactansidfabtarmonranniswolmispallasdismaprabtobrollatlonnodnavfignomnibpagsopralbilhaddocridmocpacravripfaltodtiltinhapmicfanpattaclabmogsimsonpinlomrictapfirhasbosbatpochactidhavsaplindibhosdabbitbarracparloddosbortochilmactomdigfilfasmithobharmighinradmashalraglagfadtopmophabnilnosmilfopfamdatnoldinhatnacrisfotribhocnimlarfitwalrapsarnalmoslandondanladdovrivbacpollaptalpitnambonrostonfodponsovnocsorlavmatmipfip";
var suf = "\nzodnecbudwessevpersutletfulpensytdurwepserwylsunrypsyxdyrnuphebpeglupdepdysputlughecryttyvsydnexlunmeplutseppesdelsulpedtemledtulmetwenbynhexfebpyldulhetmevruttylwydtepbesdexsefwycburderneppurrysrebdennutsubpetrulsynregtydsupsemwynrecmegnetsecmulnymtevwebsummutnyxrextebfushepbenmuswyxsymselrucdecwexsyrwetdylmynmesdetbetbeltuxtugmyrpelsyptermebsetdutdegtexsurfeltudnuxruxrenwytnubmedlytdusnebrumtynseglyxpunresredfunrevrefmectedrusbexlebduxrynnumpyxrygryxfeptyrtustyclegnemfermertenlusnussyltecmexpubrymtucfyllepdebbermughuttunbylsudpemdevlurdefbusbeprunmelpexdytbyttyplevmylwedducfurfexnulluclennerlexrupnedlecrydlydfenwelnydhusrelrudneshesfetdesretdunlernyrsebhulrylludremlysfynwerrycsugnysnyllyndyndemluxfedsedbecmunlyrtesmudnytbyrsenwegfyrmurtelreptegpecnelnevfes";

var patp2syls = function patp2syls(name) {
  return name.replace(/[\^~-]/g, '').match(/.{1,3}/g);
};

var splitAt = function splitAt(index, str) {
  return [str.slice(0, index), str.slice(index)];
};

var prefixes = pre.match(/.{1,3}/g);
var suffixes = suf.match(/.{1,3}/g);

var bex = function bex(n) {
  return two.pow(n);
};

var lsh = function lsh(a, b, c) {
  return bex(bex(a).mul(b)).mul(c);
};

var rsh = function rsh(a, b, c) {
  return c.div(bex(bex(a).mul(b)));
};

var met = function met(a, b) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : zero;
  return b.eq(zero) ? c : met(a, rsh(a, one, b), c.add(one));
};

var end = function end(a, b, c) {
  return c.mod(bex(bex(a).mul(b)));
};
/**
 * Convert a number to a @p-encoded string.
 *
 * @param  {String, Number, BN}  arg
 * @return  {String}
 */


var patp = function patp(arg) {
  var n = new BN(arg);
  var sxz = ob.feen(n);
  var dyy = met(four, sxz);

  var loop = function loop(tsxz, timp, trep) {
    var log = end(four, one, tsxz);
    var pre = prefixes[rsh(three, one, log)];
    var suf = suffixes[end(three, one, log)];
    var etc = timp.mod(four).eq(zero) ? timp.eq(zero) ? '' : '--' : '-';
    var res = pre + suf + etc + trep;
    return timp.eq(dyy) ? trep : loop(rsh(four, one, tsxz), timp.add(one), res);
  };

  var dyx = met(three, sxz);
  return '~' + (dyx.lte(one) ? suffixes[sxz] : loop(sxz, zero, ''));
};
/**
 * Convert a hex-encoded string to a @p-encoded string.
 *
 * @param  {String}  hex
 * @return  {String}
 */


var hex2patp = function hex2patp(hex) {
  return patp(new BN(hex, 'hex'));
};
/**
 * Convert a Buffer to a @p-encoded string.
 *
 * @param  {Buffer}  buf
 * @return  {String}
 */


var buf2patp = function buf2patp(buf) {
  return hex2patp(buf.toString('hex'));
};
/**
 * Convert a @p-encoded string to a hex-encoded string.
 *
 * @param  {String}  name @p
 * @return  {String}
 */


var patp2hex = function patp2hex(name) {
  if (isValidPat(name) === false) {
    throw new Error('patp2hex: not a valid @p');
  }

  var syls = patp2syls(name);

  var syl2bin = function syl2bin(idx) {
    return idx.toString(2).padStart(8, '0');
  };

  var addr = lodash.reduce(syls, function (acc, syl, idx) {
    return idx % 2 !== 0 || syls.length === 1 ? acc + syl2bin(suffixes.indexOf(syl)) : acc + syl2bin(prefixes.indexOf(syl));
  }, '');
  var bn = new BN(addr, 2);
  var hex = ob.fend(bn).toString('hex');
  return hex.length % 2 !== 0 ? hex.padStart(hex.length + 1, '0') : hex;
};
/**
 * Convert a @p-encoded string to a Buffer.
 *
 * @param  {String}  name
 * @return  {Buffer}
 */


var patp2buf = function patp2buf(name) {
  return Buffer.from(patp2hex(name), 'hex');
};
/**
 * Convert a @p-encoded string to a bignum.
 *
 * @param  {String}  name @p
 * @return  {BN}
 */


var patp2bn = function patp2bn(name) {
  return new BN(patp2hex(name), 'hex');
};
/**
 * Convert a @p-encoded string to a decimal-encoded string.
 *
 * @param  {String}  name @p
 * @return  {String}
 */


var patp2dec = function patp2dec(name) {
  return patp2bn(name).toString();
};
/**
 * Convert a number to a @q-encoded string.
 *
 * @param  {String, Number, BN}  arg
 * @return  {String}
 */


var patq = function patq(arg) {
  var bn = new BN(arg);
  var buf = bn.toArrayLike(Buffer);
  return buf2patq(buf);
};
/**
 * Convert a Buffer into a @q-encoded string.
 *
 * @param  {Buffer}  buf
 * @return  {String}
 */


var buf2patq = function buf2patq(buf) {
  var chunked = buf.length % 2 !== 0 && buf.length > 1 ? lodash.concat([[buf[0]]], lodash.chunk(buf.slice(1), 2)) : lodash.chunk(buf, 2);

  var prefixName = function prefixName(byts) {
    return lodash.isUndefined(byts[1]) ? prefixes[0] + suffixes[byts[0]] : prefixes[byts[0]] + suffixes[byts[1]];
  };

  var name = function name(byts) {
    return lodash.isUndefined(byts[1]) ? suffixes[byts[0]] : prefixes[byts[0]] + suffixes[byts[1]];
  };

  var alg = function alg(pair) {
    return pair.length % 2 !== 0 && chunked.length > 1 ? prefixName(pair) : name(pair);
  };

  return chunked.reduce(function (acc, elem) {
    return acc + (acc === '~' ? '' : '-') + alg(elem);
  }, '~');
};
/**
 * Convert a hex-encoded string to a @q-encoded string.
 *
 * Note that this preserves leading zero bytes.
 *
 * @param  {String}  hex
 * @return  {String}
 */


var hex2patq = function hex2patq(arg) {
  var hex = arg.length % 2 !== 0 ? arg.padStart(arg.length + 1, '0') : arg;
  var buf = Buffer.from(hex, 'hex');
  return buf2patq(buf);
};
/**
 * Convert a @q-encoded string to a hex-encoded string.
 *
 * Note that this preserves leading zero bytes.
 *
 * @param  {String}  name @q
 * @return  {String}
 */


var patq2hex = function patq2hex(name) {
  if (isValidPat(name) === false) {
    throw new Error('patq2hex: not a valid @q');
  }

  var chunks = lodash.split(name.slice(1), '-');

  var dec2hex = function dec2hex(dec) {
    return dec.toString(16).padStart(2, '0');
  };

  var splat = lodash.map(chunks, function (chunk) {
    var syls = splitAt(3, chunk);
    return syls[1] === '' ? dec2hex(suffixes.indexOf(syls[0])) : dec2hex(prefixes.indexOf(syls[0])) + dec2hex(suffixes.indexOf(syls[1]));
  });
  return name.length === 0 ? '00' : splat.join('');
};
/**
 * Convert a @q-encoded string to a bignum.
 *
 * @param  {String}  name @q
 * @return  {BN}
 */


var patq2bn = function patq2bn(name) {
  return new BN(patq2hex(name), 'hex');
};
/**
 * Convert a @q-encoded string to a Buffer.
 *
 * @param  {String}  name @q
 * @return  {Buffer}
 */


var patq2buf = function patq2buf(name) {
  var hex = patq2hex(name);
  return Buffer.from(hex, 'hex');
};
/**
 * Convert a @q-encoded string to a decimal-encoded string.
 *
 * @param  {String}  name @q
 * @return  {String}
 */


var patq2dec = function patq2dec(name) {
  return patq2bn(name).toString();
};
/**
 * Determine the ship class of a @p value.
 *
 * @param  {String}  @p
 * @return  {String}
 */


var clan = function clan(who) {
  var name = patp2bn(who);
  var wid = met(three, name);
  return wid.lte(one) ? 'galaxy' : wid.eq(two) ? 'star' : wid.lte(four) ? 'planet' : wid.lte(new BN(8)) ? 'moon' : 'comet';
};
/**
 * Determine the parent of a @p value.
 *
 * @param  {String}  @p
 * @return  {String}
 */


var sein = function sein(name) {
  var mir = clan(name);
  var who = patp2bn(name);
  var res = mir === 'galaxy' ? who : mir === 'star' ? end(three, one, who) : mir === 'planet' ? end(four, one, who) : mir === 'moon' ? end(five, one, who) : zero;
  return patp(res);
};
/**
 * Weakly check if a string is a valid @p or @q value.
 *
 * This is, at present, a pretty weak sanity check.  It doesn't confirm the
 * structure precisely (e.g. dashes), and for @q, it's required that q values
 * of (greater than one) odd bytelength have been zero-padded.  So, for
 * example, '~doznec-binwod' will be considered a valid @q, but '~nec-binwod'
 * will not.
 *
 * @param  {String}  name a @p or @q value
 * @return  {String}
 */


var isValidPat = function isValidPat(name) {
  var syls = patp2syls(name);
  var leadingTilde = name.slice(0, 1) === '~';
  var wrongLength = syls.length % 2 !== 0 && syls.length !== 1;
  var sylsExist = lodash.reduce(syls, function (acc, syl, index) {
    return acc && (index % 2 !== 0 || syls.length === 1 ? suffixes.includes(syl) : prefixes.includes(syl));
  }, true);
  return leadingTilde && !wrongLength && sylsExist;
};
/**
 * Remove all leading zero bytes from a sliceable value.
 * @param  {String, Buffer, Array}
 * @return  {String}
 */


var removeLeadingZeroBytes = function removeLeadingZeroBytes(str) {
  return str.slice(0, 2) === '00' ? removeLeadingZeroBytes(str.slice(2)) : str;
};
/**
 * Equality comparison, modulo leading zero bytes.
 * @param  {String, Buffer, Array}
 * @param  {String, Buffer, Array}
 * @return  {Bool}
 */


var eqModLeadingZeroBytes = function eqModLeadingZeroBytes(s, t) {
  return lodash.isEqual(removeLeadingZeroBytes(s), removeLeadingZeroBytes(t));
};
/**
 * Equality comparison on @q values.
 * @param  {String}  p a @q-encoded string
 * @param  {String}  q a @q-encoded string
 * @return  {Bool}
 */


var eqPatq = function eqPatq(p, q) {
  var phex = patq2hex(p);
  var qhex = patq2hex(q);
  return eqModLeadingZeroBytes(phex, qhex);
};

module.exports = {
  patp: patp,
  patp2hex: patp2hex,
  hex2patp: hex2patp,
  patp2dec: patp2dec,
  patq: patq,
  patq2hex: patq2hex,
  hex2patq: hex2patq,
  patq2dec: patq2dec,
  clan: clan,
  sein: sein,
  eqPatq: eqPatq,
  isValidPatq: isValidPat,
  // reserving for diff impls in future
  isValidPatp: isValidPat
};